export const getters = {
  sites (state) {
    return state.sites
  },
  site (state) {
    return state.site
  },  
  pagination(state){
    return state.pagination
  }
}
